import {Component} from 'react';
import h from 'react-hyperscript';
import List from 'Components/List/List';
import {getIndexByProperty, capitalize} from 'Src/utils/utils';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';

class AccordionItemResources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeResources: null,
      isLoaded: false,
    };
    this.stepName = capitalize(this.props.activeStep);
  }

  componentWillMount() {
    this.getActiveResources();
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeStep !== prevProps.activeStep) {
      this.getActiveResources();
    }
  }

  getActiveResources() {
    this.stepName = capitalize(this.props.activeStep);
    const index = getIndexByProperty(
        this.props.resources,
        'step',
        this.stepName
    );
    if (index > -1) {
      this.setActiveResources(this.props.resources[index]);
    }
  }

  setActiveResources(value) {
    this.setState({
      activeResources: value,
    }, () => {
      this.setState({
        isLoaded: true,
      });
    });
  }

  render() {
    if (this.state.isLoaded) {
      const activeResources = this.state.activeResources;
      const resourceCategory =
        `${activeResources.element}: ${activeResources.step}`;
      return (
        h('div', {
          id: `${this.props.id}__resources`,
          className: 'survey-result-resources',
        }, [
          h('div', {
            className: 'flex flex--align-start flex--wrap',
          }, [
            activeResources.recommended_next_steps ? h(List, {
              className: 'flex--half padding-right--md-2',
              title: `Google Recommended Next Steps: ${
                activeResources.recommended_next_steps.name
              }`,
              items: activeResources.recommended_next_steps.steps,
            }) : null,
            h(List, {
              className: 'flex--half padding-left--md-2',
              title: `Recommended Resources for ${this.props.elementTitle}`,
              items: activeResources.resources,
              resourceCategory: resourceCategory,
            }),
          ]),
        ])
      );
    } else {
      return (
        h(LoadingIndicator, null, null)
      );
    }
  }
}

export default AccordionItemResources;
